export const hyb_stark:string = 'y()u (@n W@|k)'
